import { render, staticRenderFns } from "./QuotationMessageTable.vue?vue&type=template&id=e8902090"
import script from "./QuotationMessageTable.vue?vue&type=script&lang=js"
export * from "./QuotationMessageTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports